var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.143,
    height: 20,
    viewBox: "0 0 17.143 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "generate-pdf",
    transform: "translate(-24 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M48.857,144v2.857H37.429V144H36v2.857a1.429,1.429,0,0,0,1.429,1.429H48.857a1.429,1.429,0,0,0,1.429-1.429V144Z",
    transform: "translate(-10.571 -116.286)",
    fill: "#ff2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M73.143,89l-1.01-1.01-1.847,1.847V84H68.857v5.837L67.01,87.99,66,89l3.571,3.571Z",
    transform: "translate(-37 -63.429)",
    fill: "#ff2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M136.286,13.429V12H132v7.143h1.429V16.286h2.143V14.857h-2.143V13.429Z",
    transform: "translate(-95.143 0)",
    fill: "#ff2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M80.857,19.143H78V12h2.857A2.145,2.145,0,0,1,83,14.143V17A2.145,2.145,0,0,1,80.857,19.143Zm-1.429-1.429h1.429A.715.715,0,0,0,81.571,17V14.143a.715.715,0,0,0-.714-.714H79.429Z",
    transform: "translate(-47.571 0)",
    fill: "#ff2121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M27.571,12H24v7.143h1.429V17h2.143A1.431,1.431,0,0,0,29,15.571V13.429A1.43,1.43,0,0,0,27.571,12Zm-2.143,3.571V13.429h2.143v2.143Z",
    transform: "translate(0)",
    fill: "#ff2121"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.e731611f9aebaf098cadb0ec31af0ba9.svg";
export { ForwardRef as ReactComponent };